import React, { useState, useEffect, useContext, useCallback, useMemo, useRef } from "react";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useWeb3React } from "@web3-react/core";
import ContractContext from '../../ContractContext';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { InputNumber } from 'primereact/inputnumber';
import { Text } from '@nextui-org/react'
import { Dropdown } from 'primereact/dropdown';
import { formatCurrencyExtended, formatDecimals, formatPercentage } from '../../utils';
import { miniCardHeaderStyle, miniInfoStyle, infoOutlineStyle } from './TileStyles';
import rocketfiIcon from "../../imgs/rocketfi_yellow_token.png";
import smartChainIcon from "../../imgs/smartchain.png";
import ierc20Abi from '../../contracts/ierc20Abi';
import ausdAbi from "../../contracts/ausdAbi";
import ultraTokenAbi from "../../contracts/ultraTokenAbi";
import Web3 from "web3";
import PropTypes from 'prop-types';

import { Card as NextCard } from "@nextui-org/react";

import {
    Zoom,
} from "@mui/material";

import BigNumber from 'bignumber.js';
import { Toast } from "primereact/toast";


// Dummy conversion rate and balance for illustration
const conversionRate = 1;

const containerStyle = {
    maxWidth: '1200px', // Adjust this value according to your preference
    margin: '0 auto', // Centers the container
    width: '100%', // Takes full width on smaller screens
    padding: '0 20px', // Optional padding for some spacing from the edges
};

const Convert = ({ ultraSelections, nativeSelections, selectionPairs, ultraTokenContracts }) => {
    const { account, library } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;

    const [tokenIn, setTokenIn] = useState(null);
    const [tokenOut, setTokenOut] = useState(null);
    const [tokenInBalance, setTokenInBalance] = useState(0);
    const [tokenOutBalance, setTokenOutBalance] = useState(0);
    const [amountIn, setAmountIn] = useState('');
    const [amountOut, setAmountOut] = useState('');
    // const [amountsAreEqual, setAmountsAreEqual] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectingFor, setSelectingFor] = useState(null);
    const [taxModel, setTaxModel] = useState('BNB'); // ETH or Collateral
    const [taxAmount, setTaxAmount] = useState(0);
    const [isValueNeeded, setIsValueNeeded] = useState(true);
    const [disableTaxModel, setDisableTaxModel] = useState(true);
    const [isApproving, setIsApproving] = useState(false);
    const [isConverting, setIsConverting] = useState(false);
    const [conversionPath, setConversionPath] = useState('nativeToUltra');
    const toast = useRef(null);

    const amountsAreEqual = useMemo(() => {
        return amountIn > 0 && amountOut > 0 && amountIn === amountOut;
    }, [amountIn, amountOut]);

    // Initialize state from localStorage on mount
    useEffect(() => {
        const savedTokenIn = localStorage.getItem("LOCAL_STORAGE_KEYS.TOKEN_IN");
        const savedTokenOut = localStorage.getItem("LOCAL_STORAGE_KEYS.TOKEN_OUT");
        const savedConversionPath = localStorage.getItem("LOCAL_STORAGE_KEYS.CONVERSION_PATH");

        // Helper function to find token by value
        const findTokenByValue = (value) => {
            return ultraSelections.find(t => t.value === value) || nativeSelections.find(t => t.value === value) || null;
        };

        if (savedTokenIn) {
            const tokenInObj = findTokenByValue(savedTokenIn);
            if (tokenInObj) {
                setTokenIn(tokenInObj);
            }
        }

        if (savedTokenOut) {
            const tokenOutObj = findTokenByValue(savedTokenOut);
            if (tokenOutObj) {
                setTokenOut(tokenOutObj);
            }
        }

        if (savedConversionPath) {
            setConversionPath(savedConversionPath);
        }
    }, [ultraSelections, nativeSelections]);

    // Save tokenIn to localStorage whenever it changes
    useEffect(() => {
        if (tokenIn) {
            localStorage.setItem("LOCAL_STORAGE_KEYS.TOKEN_IN", tokenIn.value);
        }
    }, [tokenIn]);

    // Save tokenOut to localStorage whenever it changes
    useEffect(() => {
        if (tokenOut) {
            localStorage.setItem("LOCAL_STORAGE_KEYS.TOKEN_OUT", tokenOut.value);
        }
    }, [tokenOut]);

    // Save conversionPath to localStorage whenever it changes
    useEffect(() => {
        if (conversionPath) {
            localStorage.setItem("LOCAL_STORAGE_KEYS.CONVERSION_PATH", conversionPath);
        }
    }, [conversionPath]);


    // Refresh balances periodically
    useEffect(() => {
        const interval = setInterval(() => {
            if (tokenIn) {
                fetchTokenBalance(tokenIn);
            }
            if (tokenOut) {
                fetchTokenBalance(tokenOut);
            }
        }, 30000); // Refresh every 30 seconds

        return () => clearInterval(interval);
    }, [tokenIn, tokenOut, library, account]);

    // const fetchTokenBalance = async (token) => {
    //     if (!library || !account || !token) return;
    //     const web3 = new Web3(library.provider);
    //     const tokenContract = new web3.eth.Contract(ierc20Abi, token.address);
    //     const balance = await tokenContract.methods.balanceOf(account).call();
    //     if (token === tokenIn) {
    //         setTokenInBalance(balance);
    //     } else if (token === tokenOut) {
    //         setTokenOutBalance(balance);
    //     }
    // };

    const fetchTokenBalance = async (token) => {
        if (!library || !account || !token) return;
        const web3 = new Web3(library.provider);
        try {
            let balance;
            if (token.value === 'BNB') { // Assuming 'BNB' is the identifier for the native token
                balance = await web3.eth.getBalance(account);
            } else {
                const tokenContract = new web3.eth.Contract(ierc20Abi, token.address);
                balance = await tokenContract.methods.balanceOf(account).call();
            }
            if (token === tokenIn) {
                setTokenInBalance(balance);
            } else if (token === tokenOut) {
                setTokenOutBalance(balance);
            }
        } catch (error) {
            console.error("Error fetching token balance:", error);
        }
    };
    

    // useEffect(() => {
    //     if (amountIn > 0 && amountOut > 0 && amountIn === amountOut) {
    //         setAmountsAreEqual(true);
    //     } else {
    //         setAmountsAreEqual(false);
    //     }
    // }, [amountIn, amountOut]);

    const fetchAllowance = async () => {
        if (!tokenIn || !account) return;
        const web3 = new Web3(library.provider);
        const tokenContract = new web3.eth.Contract(ierc20Abi, tokenIn.address);
        try {
            const currentAllowance = await tokenContract.methods.allowance(account, tokenOut.address).call();
            console.log("Current allowance:", currentAllowance);
            setAllowance(new BigNumber(currentAllowance));
        } catch (error) {
            console.error("Error fetching allowance:", error);
            setAllowance(new BigNumber(0));
        }
    };

    const requiresApproval = async () => {
        if (!account || !amountIn) return true;
        const web3 = new Web3(window.ethereum);
        const nativeIERC20 = new web3.eth.Contract(ierc20Abi, tokenIn.address);
        const contract = tokenOut.value === 'AUSD' ? ultraTokenContracts[tokenOut.address] : tokenIn.value === 'AUSD' ? ultraTokenContracts[tokenIn.address] :
        tokenOut.value.includes('Ultra') ? ultraTokenContracts[tokenOut.address] : ultraTokenContracts[tokenIn.address];

        try {
            const allowance = await nativeIERC20.methods.allowance(account, contract._address).call();
            return new BigNumber(allowance).lt(new BigNumber(amountIn));
        } catch (error) {
            console.error("Error checking allowance:", error);
            return true;
        }
    };

    const handleApprove = async () => {
        setIsApproving(true);
        console.log("Approve function called");
        if (!account || !amountIn || !tokenIn) {
            console.error("Address, account, and amountIn must be provided");
            return;
        }
        const web3 = new Web3(library.provider);
        const nativeIERC20 = new web3.eth.Contract(ierc20Abi, tokenIn.address);
        console.log("Token In", tokenIn);
        const contract = tokenOut.value === 'AUSD' ? ultraTokenContracts[tokenOut.address] : tokenIn.value === 'AUSD' ? ultraTokenContracts[tokenIn.address] :
        tokenOut.value.includes('Ultra') ? ultraTokenContracts[tokenOut.address] : ultraTokenContracts[tokenIn.address];
    
        // Convert the amountIn to a string format that BigNumber can handle
        const amountInString = new BigNumber(amountIn).toFixed(0);
        console.log("Formatted amountInString:", amountInString);
    
        try {
            const tx = nativeIERC20.methods.approve(contract._address, amountInString);
            const gasEstimate = await tx.estimateGas({ from: account });
            const transactionPromise = tx.send({
                from: account,
                gas: gasEstimate
            });
    
            // Attach event listeners directly on the Promise returned by the send method
            transactionPromise.on('transactionHash', hash => {
                toast.current.show({ severity: 'info', summary: 'Approval Submitted', detail: `Approval transaction has been submitted. Transaction Hash: ${hash}`, life: 3000 });
            });
    
            // Await the transaction to resolve
            await transactionPromise;
            toast.current.show({ severity: 'success', summary: 'Approval Success', detail: 'Approval transaction has been successfully completed.', life: 3000 });
        } catch (error) {
            console.error("Approval Error:", error);
            toast.current.show({ severity: 'error', summary: 'Approval Error', detail: error.toString(), life: 5000 });
        }
        fetchAllowance();
        setIsApproving(false);
    };
    
    const buildUltraTokenContract = useCallback((address) => {
        let web3Instance;
        web3Instance = new Web3(library.provider);
    
        if (address.toLowerCase() === "0x27874A586bafaF54d4Cd0aae368ad9569D06d115".toLowerCase())
          return new web3Instance.eth.Contract(ausdAbi, address);
        else
          return new web3Instance.eth.Contract(ultraTokenAbi, address);
      }, [library?.provider]);
    

    const handleConvert = useCallback(async () => {
        setIsConverting(true);
        if (!tokenIn || !tokenOut || !amountIn || !account) {
            console.error("All fields must be filled and you must be connected");
            return;
        }

        const amountInWei = amountIn.toString();
        const amountOutWei = amountOut.toString();
        const taxAmountWei = taxAmount.toString();
        const combinedAmountOutAndTax = new BigNumber(amountOutWei).plus(taxAmountWei).toFixed();

        console.log("Amount in", amountIn);
        console.log("Amount in:", amountInWei);
        console.log("Amount out", amountOut);
        console.log("Amount out:", amountOutWei);
        console.log("Tax amount:", taxAmountWei);
        console.log("Combined amount out and tax:", combinedAmountOutAndTax);

        console.log("Getting No less than this amount of token:", amountOutWei);
        //const contract = ultraTokenContracts[tokenOut.address];
        // const contract = tokenOut.value === 'AUSD' ? ultraTokenContracts[tokenOut.address] : tokenIn.value === 'AUSD' ? ultraTokenContracts[tokenIn.address] :
        // tokenOut.value.includes('Ultra') ? ultraTokenContracts[tokenOut.address] : ultraTokenContracts[tokenIn.address];
        const contract = tokenOut.value === 'AUSD' ? buildUltraTokenContract(tokenOut.address) : tokenIn.value === 'AUSD' ? buildUltraTokenContract(tokenIn.address) :
        tokenOut.value.includes('Ultra') ? buildUltraTokenContract(tokenOut.address) : buildUltraTokenContract(tokenIn.address);
        
        try {
            let method;
            //AUSD methods
            if (tokenIn.value === 'USDC' && tokenOut.value === 'AUSD') {
                if(taxModel === 'BNB') {
                    method = contract.methods.swapCollateralForAusdTokenUsingETHForTax(amountInWei, account);
                    setIsValueNeeded(true);
                } else {
                    method = contract.methods.swapCollateralForAusdTokenUsingCollateralForTax(amountInWei, account);
                    setIsValueNeeded(false);
                }
            } else if (tokenIn.value === 'AUSD' && tokenOut.value === 'USDC') {
                if(taxModel === 'BNB') {
                    method = contract.methods.swapAusdTokenForCollateralUsingETHForTax(amountInWei, account);
                    setIsValueNeeded(true);
                } else {
                    method = contract.methods.swapAusdTokenForCollateralUsingCollateralForTax(amountInWei, account);
                    setIsValueNeeded(false);
                }
            }
            //Ultra methods
            else if (tokenIn.value === 'BNB' && tokenOut.value.includes('Ultra')) {
                // Special case for BNB to UltraBNB, always using ETH for tax
                method = contract.methods.swapETHForUltraUsingETHForTax(account, amountOutWei);
                setIsValueNeeded(true);
            } else if (tokenIn.value.includes('Ultra') && tokenOut.value === 'BNB') {
                //console.log("methods available:", contract.methods);
                method = contract.methods.swapUltraTokenForETHUsingETHForTax(amountInWei, account, amountOutWei);
                setIsValueNeeded(false);
            } else if (tokenIn.value.includes('Ultra') && !tokenOut.value.includes('Ultra')) {
                // Converting from Ultra token to native (ETH, BTC, SOL, XRP) or any other token
                if (taxModel === 'BNB') {
                    method = contract.methods.swapUltraTokenForCollateralUsingETHForTax(amountInWei, account);
                    setIsValueNeeded(true);
                } else {
                    method = contract.methods.swapUltraTokenForCollateralUsingCollateralForTax(amountInWei, account);
                    setIsValueNeeded(false);
                }
            } else if (!tokenIn.value.includes('Ultra') && tokenOut.value.includes('Ultra')) {
                // Converting from native (ETH, BTC, SOL, XRP) or any other token to Ultra token
                if (taxModel === 'BNB') {
                    method = contract.methods.swapCollateralForUltraTokenUsingETHForTax(amountInWei, account);
                    setIsValueNeeded(true);
                } else {
                    method = contract.methods.swapCollateralForUltraTokenUsingCollateralForTax(amountInWei, account);
                    setIsValueNeeded(false);
                }
            }

            if (method) {

                const value = taxModel === 'BNB' && (tokenIn.value === 'BNB' && tokenOut.value === 'UltraBNB') // BNB to UltraBNB using ETH for tax
                    ? combinedAmountOutAndTax
                    :
                    taxModel === 'BNB' && (tokenIn.value === 'BNB' && tokenOut.value.includes('Ultra')) // BNB to UltraBNB using ETH for tax
                        ? amountInWei
                        :
                        taxModel === 'BNB' && (tokenIn.value.includes('Ultra') && tokenOut.value === 'BNB') // BNB to Ultra using ETH for tax
                            ? 0
                            :
                            taxModel === 'BNB' && (tokenIn.value.includes('Ultra') && !tokenOut.value.includes('Ultra')) // Ultra to native using ETH for tax
                                ? taxAmount
                                :
                                taxModel === 'BNB' && (!tokenIn.value.includes('Ultra') && tokenOut.value.includes('Ultra')) // Native to Ultra using ETH for tax
                                    ? taxAmount
                                    :
                                    taxModel === 'BNB' && ((tokenIn.value === 'USDC' && tokenOut.value === 'AUSD') || (tokenIn.value === 'AUSD' && tokenOut.value === 'USDC'))
                                    ? taxAmount
                                    :
                                    0 // Collateral as tax does not require any value

                //const tx = 
                const transactionPromise = method.send({
                    from: account,
                    value: isValueNeeded ? value : 0
                });

                transactionPromise.on('transactionHash', hash => {
                    toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}`, life: 3000 });
                });

                await transactionPromise;
                toast.current.show({ severity: 'success', summary: 'Transaction Successful', detail: 'Tokens have been converted successfully.', life: 3000 });

                console.log("Conversion successful");
                setAmountIn('');
                setAmountOut('');
            } else {
                console.error("Conversion method not set up for these token types");
            }
        } catch (error) {
            console.error("Conversion Error:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: 'Error - Canceled or did not convert', life: 3000 });
        }
        fetchTokenBalance(tokenIn);
        fetchTokenBalance(tokenOut);
        setIsConverting(false);
    }, [tokenIn, tokenOut, amountIn, amountOut, taxAmount, account]);

    const findPairToken = useCallback((selectedToken, isTokenIn = true) => {
        const pairTokenValue = isTokenIn ? selectionPairs[selectedToken] : Object.keys(selectionPairs).find(key => selectionPairs[key] === selectedToken);
        return pairTokenValue ? (ultraSelections.find(t => t.value === pairTokenValue) || nativeSelections.find(t => t.value === pairTokenValue)) : null;
    }, []);

    const getTokensOut = useCallback(async (tokenIn, tokenOut, amount) => {
        if (!tokenIn || !tokenOut || !amount) return 0;
        if (amount <= 0) return 0;
        if (!contracts.rocketSwapperLegacy) {
            //console.error("RocketSwapper contract not available.");
            return;
        }
        const value = new BigNumber(amount);//.times(10 ** tokenIn.decimals);

        //console.log("tokenIn:", tokenIn);
        //console.log("tokenOut:", tokenOut);
        //console.log("value:", value.toString());

        try {
            const _tokensOut = await contracts.rocketSwapperLegacy.methods.getAmountOutMin(tokenIn.address, tokenOut.address, value.toFixed()).call();
            //console.log("_tokensOut:", _tokensOut);
            return _tokensOut;
        } catch (error) {
            console.error("Error interacting with the Rocket Swapper contract:", error);
        }
    }, [contracts]);

    const handleAmountInChange = useCallback(async (newAmountIn) => {
        const amountInBig = new BigNumber(newAmountIn);
        console.log("Amount in:", amountInBig.toFixed(0));
        setAmountIn(amountInBig.toFixed(0));

        const isTokenInUltra = ultraSelections.some(ut => ut.value === tokenIn?.value);
        const isTokenOutUltra = ultraSelections.some(ut => ut.value === tokenOut?.value);

        const contract = tokenOut.value === 'AUSD' ? ultraTokenContracts[tokenOut.address] : tokenIn.value === 'AUSD' ? ultraTokenContracts[tokenIn.address] :
        tokenOut.value.includes('Ultra') ? ultraTokenContracts[tokenOut.address] : ultraTokenContracts[tokenIn.address];


        let newAmountOut = new BigNumber(0);
        let takeAdditional = true;

        const taxRate = new BigNumber('0.02');
        const taxAmount = amountInBig.multipliedBy(taxRate).decimalPlaces(0, BigNumber.ROUND_DOWN);



        if (tokenIn?.value === 'USDC' && tokenOut?.value === 'AUSD') {
            newAmountOut = amountInBig;
            if (taxModel === 'BNB') {
                const fee = await contract.methods.getFeeAsETH(amountInBig.toFixed(0), account).call();
                setTaxAmount(new BigNumber(fee).toFixed(0));
                setDisableTaxModel(false);
                takeAdditional = false;
            } else {
                setTaxAmount(taxAmount.toFixed(0));
                newAmountOut = amountInBig.minus(taxAmount);
                setDisableTaxModel(false);
                takeAdditional = true;
            }
        }
        else if (tokenIn?.value === 'AUSD' && tokenOut?.value === 'USDC') {
            if (taxModel === 'BNB') {
                const fee = await contract.methods.getFeeAsETH(amountInBig.toFixed(0), account).call();
                setTaxAmount(new BigNumber(fee).toFixed(0));
                newAmountOut = amountInBig;
                setDisableTaxModel(false);
                takeAdditional = false;
            } else {
                setTaxAmount(taxAmount.toFixed(0));
                newAmountOut = amountInBig.minus(taxAmount);
                setDisableTaxModel(false);
                takeAdditional = true;
            }
        }

        else if (tokenIn?.value === 'BNB' && tokenOut?.value === 'UltraBNB') {
            setTaxAmount(taxAmount.toFixed(0));
            setDisableTaxModel(true);
            setTaxModel('BNB');
            newAmountOut = amountInBig.minus(taxAmount);
        } else if (tokenIn?.value === 'BNB' && tokenOut?.value.includes('Ultra')) {
            setTaxAmount(taxAmount.toFixed(0));
            setDisableTaxModel(true);
            setTaxModel('BNB');
            const adjustedAmountIn = amountInBig.minus(taxAmount);
            const nativePair = findPairToken(tokenOut?.value, false);
            newAmountOut = new BigNumber(await getTokensOut(tokenIn, nativePair, adjustedAmountIn.toFixed(0)));
        } else if (isTokenInUltra && !isTokenOutUltra) {
            if (tokenOut?.value === 'BNB') {
                if (tokenIn?.value === 'UltraBNB') {
                    setTaxAmount(taxAmount.toFixed(0));
                    setDisableTaxModel(true);
                    setTaxModel('BNB');
                    newAmountOut = amountInBig.minus(taxAmount);
                } else {
                    const BNBAmountOut = await getTokensOut(findPairToken(tokenIn?.value, true), tokenOut, amountInBig.toFixed(0));
                    const BNBAmountOutBig = new BigNumber(BNBAmountOut);
                    setTaxAmount(BNBAmountOutBig.multipliedBy(taxRate).toFixed(0));
                    setDisableTaxModel(true);
                    setTaxModel('BNB');
                    newAmountOut = BNBAmountOutBig.minus(BNBAmountOutBig.multipliedBy(taxRate));
                }
            } else {
                if (taxModel === 'BNB') {
                    const fee = await contract.methods.getFeeAsETH(amountInBig.toFixed(0), account).call();
                    setTaxAmount(new BigNumber(fee).toFixed(0));
                    newAmountOut = amountInBig;
                    setDisableTaxModel(false);
                    takeAdditional = false;
                } else {
                    setTaxAmount(taxAmount.toFixed(0));
                    newAmountOut = amountInBig.minus(taxAmount);
                    setDisableTaxModel(false);
                    takeAdditional = true;
                }
            }
        } else if (!isTokenInUltra && isTokenOutUltra) {
            newAmountOut = amountInBig;
            if (taxModel === 'BNB') {
                const fee = await contract.methods.getFeeAsETH(amountInBig.toFixed(0), account).call();
                setTaxAmount(new BigNumber(fee).toFixed(0));
                setDisableTaxModel(false);
                takeAdditional = false;
            } else {
                setTaxAmount(taxAmount.toFixed(0));
                newAmountOut = amountInBig.minus(taxAmount);
                setDisableTaxModel(false);
                takeAdditional = true;
            }
        }
      

        setAmountOut(takeAdditional ? newAmountOut.multipliedBy(new BigNumber('0.999')).toFixed(0) : newAmountOut.toFixed(0));
    }, [tokenIn, tokenOut, ultraTokenContracts, taxModel, findPairToken, getTokensOut]);


    const handleMaxIn = useCallback(() => {
        setAmountIn(tokenInBalance ? tokenInBalance : 0);
        //setAmountOut(tokenInBalance ? tokenInBalance * conversionRate : 0);
    }, [tokenInBalance]);

    const handleMaxOut = () => {
        const maxOut = tokenOutBalance / conversionRate;
        setAmountIn(maxOut);
        setAmountOut(tokenOutBalance);
    };

    // Fetch token balance with error handling
    const getTokenBalance = useCallback(async (token) => {
        try {
            if (!library?.provider || !token) return 0;
            //console.log("Token object:", token); // Debugging line
            const web3 = new Web3(library.provider);

            if (token.value === 'BNB') {
                const balance = await web3.eth.getBalance(account);
                return balance;
            } else {
                //console.log("Token address:", token.address); // Debugging line
                const contract = new web3.eth.Contract(ierc20Abi, token.address);
                const balance = await contract.methods.balanceOf(account).call();
                return balance;
            }
        } catch (error) {
            console.error("Error fetching token balance:", error);
            return 0;
        }
    }, [account, library]);



    let USDC = "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"

    const getTokenPrice = useCallback(async (token, amount) => {
        if (!token || !amount) return 0;

        try {
            // Check if the token is an Ultra token and find its native pair
            let tokenForPriceCheck = token;
            if (ultraSelections.some(ut => ut.value === token.value)) {
                const nativePairToken = findPairToken(token.value, false);
                tokenForPriceCheck = nativePairToken;
            }

            // Now get the USD value using the native token
            const usdValue = await getTokensOut(tokenForPriceCheck, { address: USDC }, amount);
            return usdValue;
        } catch (error) {
            console.error("Error getting token price:", error);
            return 0;
        }
    }, [findPairToken, getTokensOut]);

    const getFeeInUSD = useCallback(async (inputValue) => {
        const result = await contracts.feeHook.methods.calculateFeeInUSD(account, inputValue).call();
        //console.log("getIsRegistered for", smartCode, ":", result);
        return result;
    }, [contracts]);



    useEffect(() => {
        if (tokenIn && tokenOut && amountIn) {
            handleAmountInChange(Math.floor(amountIn));
        }
    }, [tokenIn, tokenOut, amountIn]);

    useEffect(() => {
        if (amountIn) {
            handleAmountInChange(Math.floor(amountIn));
        }
    }, [taxModel, amountIn, handleAmountInChange]);


    // Fetch and set token balances when the selected token changes
    useEffect(() => {
        if (tokenIn && tokenIn.address) {
            getTokenBalance(tokenIn).then(balance => setTokenInBalance(balance));
        } else {
            setTokenInBalance(0);
        }
    }, [tokenIn, account, library]);

    useEffect(() => {
        if (tokenOut && tokenOut.address) {
            getTokenBalance(tokenOut).then(balance => setTokenOutBalance(balance));
        } else {
            setTokenOutBalance(0);
        }
    }, [tokenOut, account, library]);





    // Function to toggle conversion path
    const toggleConversionPath = useCallback(async () => {
        const newConversionPath = conversionPath === 'nativeToUltra' ? 'ultraToNative' : 'nativeToUltra';
        setConversionPath(newConversionPath);

        let newTokenIn, newTokenOut;

        // Check if the current selection is BNB to UltraToken
        if (tokenIn?.value === 'BNB' && ultraSelections.some(ut => ut.value === tokenOut?.value)) {
            // If switching from BNB -> UltraToken to UltraToken -> BNB
            newTokenIn = ultraSelections.find(ut => ut.value === tokenOut?.value); // Keep the same Ultra token
            newTokenOut = nativeSelections.find(t => t.value === 'BNB'); // Set BNB as token out
        } else if (tokenOut?.value === 'BNB' && ultraSelections.some(ut => ut.value === tokenIn?.value)) {
            // If switching from UltraToken -> BNB to BNB -> UltraToken
            newTokenIn = nativeSelections.find(t => t.value === 'BNB'); // Set BNB as token in
            newTokenOut = ultraSelections.find(ut => ut.value === tokenIn?.value); // Keep the same Ultra token
        } else {
            // For all other cases
            newTokenIn = tokenOut;
            newTokenOut = tokenIn;
        }

        // Fetch and set new balances for the switched tokens
        let newTokenInBalance = 0;
        if (newTokenIn && newTokenIn.address) {
            newTokenInBalance = await getTokenBalance(newTokenIn);
            setTokenInBalance(newTokenInBalance);
        } else {
            setTokenInBalance(0);
        }

        if (newTokenOut && newTokenOut.address) {
            getTokenBalance(newTokenOut).then(balance => setTokenOutBalance(balance));
        } else {
            setTokenOutBalance(0);
        }

        setTokenIn(newTokenIn);
        setTokenOut(newTokenOut);

        // Reset amountIn if it's greater than the new balance
        if (new BigNumber(amountIn).isGreaterThan(newTokenInBalance)) {
            setAmountIn(newTokenInBalance);
            // Recalculate amountOut based on new amountIn
            await handleAmountInChange(Math.floor(newTokenInBalance));
        }
    }, [tokenIn, tokenOut, amountIn, conversionPath]);



    // Updated handleTokenSelect function
    const handleTokenSelect = (token) => {
        if (selectingFor === 'in') {
            setTokenIn(token);
            setAmountIn(''); // Reset the amountIn to empty
            setAmountOut(''); // Reset the amountOut to empty

            if (token.value === 'USDC') {
                setTokenOut(ultraSelections.find(t => t.value === 'AUSD'));
            } else if (token.value === 'AUSD') {
                setTokenOut(nativeSelections.find(t => t.value === 'USDC'));
            }

            if(token.value === 'BNB' && ( tokenOut?.value === 'AUSD' || tokenOut?.value === 'USDC')) {
                //default tokentOut to findPairToken
                const pairToken = findPairToken(token.value);
                setTokenOut(pairToken);
                setTaxModel('BNB');
            }

            if ((token.value === 'BNB' && conversionPath === 'nativeToUltra') || (tokenOut?.value === 'BNB' && conversionPath === 'ultraToNative')) {
                // Do not change tokenOut if it's BNB or tokenIn is BNB
            } else {
                // Set tokenOut based on pair
                const pairToken = findPairToken(token.value);
                setTokenOut(pairToken);
                setTaxModel('BNB');
            }
        } else if (selectingFor === 'out') {
            setTokenOut(token);
            setAmountIn(''); // Reset the amountIn to empty
            setAmountOut(''); // Reset the amountOut to empty


            if (token.value === 'USDC') {
                setTokenIn(ultraSelections.find(t => t.value === 'AUSD'));
            } else if (token.value === 'AUSD') {
                setTokenIn(nativeSelections.find(t => t.value === 'USDC'));
            }

            if(token.value === 'BNB' && ( tokenIn?.value === 'AUSD' || tokenIn?.value === 'USDC')) {
                //default tokentIn to findPairToken
                const pairToken = findPairToken(token.value, false);
                setTokenIn(pairToken);
                setTaxModel('BNB');
            }
            

            if ((token.value === 'BNB' && conversionPath === 'ultraToNative') || (tokenIn?.value === 'BNB' && conversionPath === 'nativeToUltra')) {
                // Do not change tokenIn if it's BNB or tokenOut is BNB
            } else {
                // Set tokenIn based on pair
                const pairToken = findPairToken(token.value, false);
                setTokenIn(pairToken);
                setTaxModel('BNB');
            }
        }
        setShowModal(false);
    };







    const handleTokenClick = (type) => {
        setSelectingFor(type);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const switchButtonLabel = conversionPath === 'nativeToUltra' ? "Convert to Native" : "Convert to Ultra";

    const getTokenImageSrc = (token) => {
        return token ? token.img : null;
    };

    const renderTradeSummary = () => {
        const tokenInImgSrc = getTokenImageSrc(tokenIn);
        const tokenOutImgSrc = getTokenImageSrc(tokenOut);

        // Determine if there is an intermediate step in both directions of the conversion
        const isIntermediateStepNativeToUltra = tokenIn?.value === 'BNB' && tokenOut?.value !== 'UltraBNB' && conversionPath === 'nativeToUltra';
        const isIntermediateStepUltraToNative = tokenOut?.value === 'BNB' && tokenIn?.value !== 'UltraBNB' && conversionPath === 'ultraToNative';

        let intermediateTokenImgSrc;
        if (isIntermediateStepNativeToUltra || isIntermediateStepUltraToNative) {
            const intermediateTokenValue = isIntermediateStepNativeToUltra ? tokenOut?.value : tokenIn?.value;
            const intermediateToken = findPairToken(intermediateTokenValue, !isIntermediateStepNativeToUltra);
            intermediateTokenImgSrc = getTokenImageSrc(intermediateToken);
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                {tokenInImgSrc && <img src={tokenInImgSrc} alt="Token In" style={{ width: '35px' }} />}
                {(isIntermediateStepNativeToUltra || isIntermediateStepUltraToNative) && intermediateTokenImgSrc && (
                    <>
                        <i className="pi pi-arrow-right" style={{ fontSize: '1em' }}></i>
                        <img src={intermediateTokenImgSrc} alt="Intermediate Token" style={{ width: '35px' }} />
                    </>
                )}
                <i className="pi pi-arrow-right" style={{ fontSize: '1em' }}></i>
                {tokenOutImgSrc && <img src={tokenOutImgSrc} alt="Token Out" style={{ width: '35px' }} />}
            </div>
        );
    };


    const renderRewardSummary = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '10px', fontSize: '24px' }}>
                0 {rocketfiIcon && <img src={rocketfiIcon} alt="RocketFi" style={{ width: '25px' }} />}
            </div>
        );
    };


    // Add a state to track the window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Function to determine if the screen is in desktop mode
    const isDesktop = () => windowWidth >= 768; // Adjust the breakpoint as needed

    // Determine the gradient style for the conversion summary based on the conversion path
    const conversionSummaryStyle = useMemo(() => {
        return conversionPath !== 'nativeToUltra' ? conversionSummaryStyleNative : conversionSummaryStyleUltra;
    }, [conversionPath]);

    const calculatePercentageAmount = useCallback((percentage) => {
        return tokenInBalance ? (tokenInBalance * percentage) / 100 : 0;
    }, [tokenInBalance]);


    const isNativeToUltraConversion = () => {
        return conversionPath === 'nativeToUltra';
    };

    const updateAmountInAndAmountOutandSetTaxModel = (newTaxModel) => {
        setTaxModel(newTaxModel);
        if (amountIn) { // Trigger re-calculation when tax model changes
            handleAmountInChange(amountIn);
        }
    };

    const renderTaxModelDropdown = () => {
        return (
            !disableTaxModel &&
            <>
                <div style={{ fontSize: '12px' }}>
                    Fee payment method:</div>
                <Dropdown
                    value={taxModel}
                    options={['BNB', 'Collateral']}
                    onChange={(e) => updateAmountInAndAmountOutandSetTaxModel(e.value)}
                    placeholder="Tax model"
                    style={{

                        backgroundColor: 'transparent',
                        borderRadius: '25px',
                        fontSize: '0.8rem',
                    }}
                />
            </>
        );
    };

    const [allowance, setAllowance] = useState(new BigNumber(0));

    useEffect(() => {
        const fetchAllowance = async () => {
            if (!tokenIn || !tokenOut || !account) return;
            const web3 = new Web3(library.provider);
            const tokenContract = new web3.eth.Contract(ierc20Abi, tokenIn.address);
            try {
                const currentAllowance = await tokenContract.methods.allowance(account, tokenOut.address).call();
                //console.log("Current allowance:", currentAllowance);
                setAllowance(new BigNumber(currentAllowance));
            } catch (error) {
                console.error("Error fetching allowance:", error);
                setAllowance(new BigNumber(0));
            }
        };
        fetchAllowance();
    }, [account, tokenInBalance, tokenOutBalance, tokenIn, tokenOut, library]);

    //const insufficientAllowance = allowance.isLessThan(amountIn);
    // const [insufficientAllowance, setInsufficientAllowance] = useState(false);

    // useEffect(() => {
    //     setInsufficientAllowance(allowance.isLessThan(amountIn));
    //     // console.log("Insufficient allowance:", insufficientAllowance);
    //     // console.log("Allowance:", allowance.toString());
    //     // console.log("Amount in:", amountIn);
    // }, [allowance, amountIn, tokenInBalance, tokenOutBalance,]);

    const insufficientAllowance = useMemo(() => {
        return allowance.isLessThan(amountIn);
    }, [allowance, amountIn]);
    

    // const ConversionSummary = ({ conversionPath, amountIn, amountOut, taxModel, taxAmount }) => {
    //     return (
    //       <div style={{ padding: '10px', backgroundColor: 'lightgrey', borderRadius: '5px', marginTop: '20px' }}>
    //         <h4>Conversion Summary:</h4>
    //         <p><strong>Conversion Path:</strong> {conversionPath}</p>
    //         <p><strong>Amount In:</strong> {formatDecimals(amountIn)} {conversionPath.startsWith('native') ? 'BNB' : 'UltraToken'}</p>
    //         <p><strong>Amount Out:</strong> {formatDecimals(amountOut)} {conversionPath.endsWith('Ultra') ? 'UltraToken' : 'BNB'}</p>
    //         <p><strong>Tax:</strong> {taxModel}: {findPairToken(tokenOut?.value)}: {formatCurrencyExtended(taxAmount)}</p>
    //       </div>
    //     );
    //   };

    // const ConversionSummary = ({ tokenIn, tokenOut, amountIn, amountOut, taxModel, taxAmount, requiresApproval }) => {
    //     const [allowance, setAllowance] = useState(null);

    //     // Fetch the allowance if needed
    //     useEffect(() => {
    //         const fetchAllowance = async () => {
    //             if (requiresApproval) {
    //                 // Assuming `web3` and `ierc20Abi` are accessible here
    //                 const web3 = new Web3(library.provider);
    //                 const tokenContract = new web3.eth.Contract(ierc20Abi, tokenIn.address);
    //                 const allowance = await tokenContract.methods.allowance(account, tokenOut.address).call();
    //                 setAllowance(allowance);
    //             }
    //         };

    //         fetchAllowance();
    //     }, [requiresApproval, tokenIn, tokenOut, account, library]);

    //     return (
    //         <div style={{ padding: '10px', backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '15px', marginTop: '10px' }}>
    //             <h4>Conversion Summary:</h4>
    //             <p><strong>Amount In:</strong> {amountIn} {tokenIn?.symbol}</p> {formatDecimals(amountIn, tokenIn?.decimals)}
    //             <p><strong>Amount Out:</strong> {amountOut} {tokenOut?.symbol}</p> {formatDecimals(amountOut, tokenOut?.decimals)}
    //             <p><strong>Tax:</strong> {taxAmount} {taxModel === 'BNB' ? 'BNB' : 'Collateral'} </p>
    //             {taxModel === 'Collateral' && <p><strong>Fee Paid in:</strong> {findPairToken(tokenOut?.value)}</p>}
    //             {requiresApproval && <p><strong>Token Allowance:</strong> {formatDecimals(allowance, tokenIn?.decimals

    //             )}</p>}
    //         </div>
    //     );
    // };



    return (
        <div style={{ ...containerStyle, marginBottom: '50px' }}>
            <div style={{
                ...infoOutlineStyle, alignContent: 'center', justifyContent: 'center', textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold', color: 'white',
                paddingTop: '10px', paddingBottom: '10px', paddingLeft: '5px', paddingRight: '5px',
            }}>UltraBlue Converter</div>
            <div style={{ display: 'flex', flexDirection: isDesktop() ? 'row' : 'column', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
                <TokenInput
                    onSelectToken={() => handleTokenClick('in')}
                    token={tokenIn}
                    balance={tokenInBalance}
                    onAmountChange={handleAmountInChange}
                    calculatePercentageAmount={calculatePercentageAmount}
                    amountIn={amountIn}
                    getTokenPrice={getTokenPrice}
                    getFeeInUSD={getFeeInUSD}
                    ultraSelections={ultraSelections}
                    renderTaxModelDropdown={renderTaxModelDropdown}
                    amountsAreEqual={amountsAreEqual}
                />
                {/* {!disableTaxModel && <Dropdown
                    value={taxModel} options={['BNB', 'Collateral']} onChange={(e) => updateAmountInAndAmountOutandSetTaxModel(e.value)} placeholder="Tax model" />} */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center', // Center horizontally
                        alignItems: 'center', // Center vertically if needed
                        padding: '15px 15px 15px 15px', // Optional: to provide some spacing around the button
                    }}
                >
                    <Button
                        onClick={toggleConversionPath}
                        //outlined
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            width: '50px',
                            height: '50px',
                            borderRadius: '25px',
                            // marginTop: '15px', marginBottom: '15px',
                            // marginLeft: '15px', marginRight: '15px',
                        }}
                    >
                        <i className="pi pi-arrow-right-arrow-left" style={{ transform: isDesktop() ? '' : 'rotate(90deg)' }}></i>
                        {/* <span>{switchButtonLabel}</span> */}
                    </Button>
                </div>
                <TokenOutput
                    onSelectToken={() => handleTokenClick('out')}
                    token={tokenOut}
                    balance={tokenOutBalance}
                    amountOut={amountOut}
                    getTokenPrice={getTokenPrice}
                    ultraSelections={ultraSelections}
                    amountsAreEqual={amountsAreEqual}
                />


            </div>
            {tokenIn && tokenOut &&
                <Zoom in={true} style={{ transitionDelay: 50 }}>
                    <div style={conversionSummaryStyle}>
                        Conversion Summary {renderTradeSummary()}
                    </div>
                </Zoom>
            }

            <div
                style={{
                    borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px', backgroundColor: 'black',
                    //paddingTop: '10px', paddingBottom: '10px', paddingLeft: '5px', paddingRight: '5px',
                }}
            >

                {
                   ( tokenIn?.value === 'AUSD' || tokenOut?.value === 'AUSD') &&
                    <Message severity="info" text="AUSD earns from its own ecosystem but each trade benefits UltraBlue rewards."
                    style={{display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', textAlign: 'center', padding: '10px', width: 'auto'}}
                    />

                }
                {
                    requiresApproval(tokenIn?.address, account, amountIn) && (tokenOut?.value.includes('Ultra') || tokenOut?.value.includes('AUSD')) && tokenIn?.value !== 'BNB' && insufficientAllowance &&
                    <Button label={isApproving ? "Approving..." : "Approve"} onClick={handleApprove}
                        disabled={isApproving || !tokenIn || !tokenOut || !amountIn || amountIn <= 0} //0.000000954760668193
                        //disabled
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center', // Center the contents
                            gap: '10px',
                            width: '100%', // Minimum width for each button
                            height: '50px',
                            borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
                            borderTopLeftRadius: '25px', borderTopRightRadius: '25px',
                            marginTop: '15px', marginBottom: '15px',
                        }}
                    />}

                <Button label={isConverting ? "Converting..." : "Convert"} onClick={handleConvert}
                    disabled={isConverting || !tokenIn || !tokenOut || !amountIn || amountIn <= 0 || (requiresApproval(tokenIn?.address, account, amountIn) && tokenOut?.value.includes('Ultra') && tokenIn?.value !== 'BNB' && insufficientAllowance)}
                    //disabled
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center', // Center the contents
                        gap: '10px',
                        width: '100%', // Minimum width for each button
                        height: '50px',
                        borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
                        borderTopLeftRadius: '25px', borderTopRightRadius: '25px',
                        marginTop: '15px', marginBottom: '15px',
                    }}
                />
            </div>


            {showModal && (
                <TokenSelectorModal
                    tokens={selectingFor === (conversionPath === 'nativeToUltra' ? 'in' : 'out') ? nativeSelections : ultraSelections}
                    onSelect={handleTokenSelect}
                    onClose={handleCloseModal}
                    isVisible={showModal}
                    setShowModal={setShowModal}
                />
            )}
            <Toast ref={toast} />
        </div>

    );
};



export default React.memo(Convert);

const conversionSummaryStyleNative = {
    alignContent: 'center', justifyContent: 'center', textAlign: 'center',
    fontSize: '1rem', fontWeight: 'bold', color: 'white', padding: '10px',
    borderRadius: '25px',
    backgroundImage: 'linear-gradient(to right, rgb(0, 35, 185), rgb(0, 116, 245))', // Blue gradient
    marginTop: '15px', marginBottom: '10px', width: 'auto'
};

const conversionSummaryStyleUltra = {
    alignContent: 'center', justifyContent: 'center', textAlign: 'center',
    fontSize: '1rem', fontWeight: 'bold', color: 'white', padding: '10px',
    borderRadius: '25px',
    backgroundImage: 'linear-gradient(to right, rgb(0, 116, 245), rgb(0, 35, 185))', // Blue gradient
    marginTop: '15px', marginBottom: '10px', width: 'auto'
};


const tokenCardStyle = (image) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // Align children from top to bottom
    alignContent: 'start',
    width: '100%',
    padding: '15px',
    backgroundImage: `linear-gradient(263deg, rgb(9, 116, 217), rgb(0, 116, 255)), linear-gradient(153deg,rgb(0, 0, 0), rgb(0, 0, 0) 19%, rgb(0, 0, 0))`,
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    borderTopLeftRadius: '25px',
    borderTopRightRadius: '25px',
    borderBottomLeftRadius: '25px',
    borderBottomRightRadius: '25px',
    minHeight: '200px', // Adjust as needed
});


const ultraTokenCardStyle = (image) => ({
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between', // Align children from top to bottom
    alignContent: 'start',
    width: '100%', padding: '15px',
    backgroundImage: `linear-gradient(263deg, rgb(9, 64, 245), rgb(0, 35, 185)), linear-gradient(153deg,rgb(0, 0, 0), rgb(0, 0, 0) 19%, rgb(0, 0, 0))`,
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    borderTopLeftRadius: '25px', borderTopRightRadius: '25px', borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
    minHeight: '200px',
});


const TokenSelectorModal = React.memo(({ tokens, onSelect, isVisible, setShowModal }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredTokens = searchTerm
        ? tokens.filter(token => token.label.toLowerCase().includes(searchTerm.toLowerCase()))
        : tokens;

    return (
        <Dialog
            header="Select a Token"
            visible={isVisible}
            style={{ width: '75%', maxWidth: '300px' }}  // Adjust width as needed
            onHide={() => setShowModal(false)}
        >
            <div>
                <InputText
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search tokens"
                    style={{ width: '100%', marginBottom: '10px', borderRadius: '10px' }}
                />
                <div style={{
                    display: 'flex', flexDirection: 'column', gap: '10px',
                    alignContent: 'center', justifyContent: 'center', textAlign: 'center',
                    alignItems: 'center', borderRadius: '25px',
                }}>
                    {filteredTokens.map(token => (
                        <Button
                            key={token.value}
                            //className="p-button-outlined p-button-rounded"
                            onClick={() => onSelect(token)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center', // Center the contents
                                gap: '10px',
                                width: '75%', // Minimum width for each button
                                backgroundColor: 'black', color: 'white',
                                borderRadius: '25px',
                            }}
                        >
                            <img src={token.img} alt={token.label} style={{ width: '20px' }} />
                            {token.label}
                        </Button>
                    ))}
                </div>
            </div>
        </Dialog>
    );
});

// const TokenSelectButton2 = React.memo(({ onClick, token, isUltraSelection }) => (
//     <Button
//         onClick={onClick}
//         className='p-button-rounded p-button-text p-button-plain'
//         style={{
//             display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '10px', fontSize: '18px',
//             borderRadius: '25px', backgroundColor: 'black', color: 'white',
//             width: '100%', height: '50px',
//             justifyContent: 'center', textAlign: 'center', fontWeight: 'bold', paddingTop: '10px', paddingBottom: '10px',
//             maxWidth: '50%',
//             minWidth: '60%',
//         }}
//     >
//         <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
//             {token && token.img && <img src={token.img} alt={token.label} style={{ width: isUltraSelection ? '35px' : '25px' }} />}
//             <span>{token ? token.label : 'Select Token'}</span>

//         </div>
//         <i className="pi pi-chevron-down" style={{
//             fontSize: '0.5em',
//             marginTop: '3px', marginLeft: '5px'
//         }}></i>
//     </Button>
// ));

const TokenSelectButton = React.memo(({ onClick, token, isUltraSelection }) => (
    <NextCard
        isPressable
        isHoverable
        variant="bordered"
        css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'black',
            color: 'white',
            borderRadius: '25px',
            padding: '0px',
            marginBottom: '10px',
            maxWidth: '50%',
            minWidth: '60%',
            minHeight: '45px',
            cursor: 'pointer',
            overflow: 'hidden',
            // transition: 'background-color 0.3s',
            // '&:hover': {
            //     backgroundColor: '#333333',
            // },
            // '&:active': {
            //     backgroundColor: '#000000',
            // }
        }}
        onClick={onClick}
    >
        <NextCard.Body style={{
            padding: '3px',
            overflow: 'hidden',
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', fontSize: '18px' }}>
                {token && token.img && (
                    <img src={token.img} alt={token.label} style={{ width: isUltraSelection ? '35px' : '25px' }} />
                )}
                <span>{token ? token.label : 'Select Token'}</span>
                {/* <Text size={18} css={{ color: 'white', fontWeight: 'bold',}}>{token ? token.label : 'Select Token'}</Text> */}
                <i className="pi pi-chevron-down" style={{ fontSize: '0.5em', marginTop: '3px', marginLeft: '3px' }}></i>
            </div>
        </NextCard.Body>
    </NextCard>
));

const TokenInput = React.memo(({ onSelectToken, token, balance, onAmountChange, calculatePercentageAmount, amountIn, getTokenPrice, getFeeInUSD, ultraSelections, renderTaxModelDropdown, amountsAreEqual }) => {
    const [balanceUSD, setBalanceUSD] = useState(0);
    const [amountInUSD, setAmountInUSD] = useState(0);
    const [feeAmountInUSD, setFeeAmountInUSD] = useState(0);

    const handlePercentageClick = (percentage) => {
        const calculatedAmount = new BigNumber(calculatePercentageAmount(percentage).toFixed(0));
        onAmountChange(calculatedAmount);
    };

    useEffect(() => {
        if (!amountIn || amountIn === 0) {
            setAmountInUSD(0);
        }
        getTokenPrice(token, amountIn).then(setAmountInUSD);
    }, [amountIn]);

    useEffect(() => {
        if (!balance || balance === 0) {
            setBalanceUSD(0);
        }
        getTokenPrice(token, balance).then(setBalanceUSD);

    }, [balance]);


    useEffect(() => {
        if (!amountInUSD || amountInUSD === 0) {
            setFeeAmountInUSD(0);
            return;

        }
        getFeeInUSD(amountInUSD).then(setFeeAmountInUSD);
    }, [amountInUSD]);


    // Determine if the token is an Ultra token to apply specific style
    const isUltraToken = ultraSelections.some(ut => ut.value === token?.value);
    const tokenStyle = isUltraToken ? ultraTokenCardStyle(token?.img) : tokenCardStyle(token?.img);

    return (
        <div style={{ ...tokenStyle, border: amountsAreEqual ? '2px solid yellow' : 'none', }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <TokenSelectButton onClick={() => onSelectToken('in')} token={token} isUltraSelection={isUltraToken} />
                <div style={{
                    textAlign: 'right', color: 'white', marginLeft: '5px',
                    backgroundColor: 'rgba(0, 0, 0, 0.1)', paddingRight: '10px', paddingLeft: '10px', paddingTop: '8px', paddingBottom: '8px',
                    borderRadius: '10px',
                    alignContent: 'center', justifyContent: 'center', alignItems: 'center', fontSize: '12px',
                }}>

                    <strong> Balance:</strong> {token ? formatDecimals(balance, token.decimals) : '0'} {'(' + formatCurrencyExtended(balanceUSD / 10 ** 18) + ')'}
                </div>
            </div>
            <div
                style={{
                    borderRadius: '15px', //border: '1px solid white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    //color: 'white',
                    paddingBottom: '8px', paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px', marginTop: '5px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <InputNumber
                        value={amountIn / 10 ** token?.decimals || ''}
                        //onValueChange={(e) => onAmountChange(e.value * 10 ** token?.decimals)}
                        onChange={(e) => onAmountChange(e.value * 10 ** token?.decimals)}
                        mode="decimal"
                        //minFractionDigits={0}
                        maxFractionDigits={token?.decimals}
                        min={0}
                        style={{ flex: 1, borderRadius: '25px', }}
                        inputStyle={{
                            background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontSize: '24px', fontWeight: 'thin',
                            paddingBottom: '0px', paddingTop: '0px'
                        }}
                        placeholder="0"
                       inputMode="decimal"
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'flex-end', gap: '10px', marginTop: '10px',
                    }}>
                        {/* Percentage Buttons */}
                        {[25, 50, 75, 100].map((percentage) => (
                            <Button key={percentage} label={`${percentage}%`} onClick={() => handlePercentageClick(percentage)}
                                style={{
                                    background: 'transparent', color: 'white',
                                    borderRadius: '25px', fontSize: '10px',
                                    padding: '3px 6px 3px 6px',
                                }}
                            />
                        ))}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '10px' }}>

                        ~{formatCurrencyExtended(amountInUSD / 10 ** 18)}
                    </div>

                </div>



            </div>

            <div style={{
                textAlign: 'right', color: 'white', marginTop: '8px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)', paddingRight: '15px', paddingLeft: '9px', paddingTop: '3px', paddingBottom: '3px',
                borderRadius: '25px',
                alignContent: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', gap: '10px',
                alignSelf: 'end',
                maxWidth: '100%',
            }}>

                {/* <div style={{ fontSize: '12px' }}>
                    BNB Conversion Fee: {amountInUSD > 0 ? formatPercentage(feeAmountInUSD / amountInUSD) : '0%'} {'(' + formatCurrencyExtended(feeAmountInUSD / 10 ** 18) + ')'}
                </div> */}
                {renderTaxModelDropdown()} <br />
                <div style={{ fontSize: '12px' }}>
                    Fee: {amountInUSD > 0 ? formatPercentage(0.02) : '0%'} {'(' + formatCurrencyExtended(amountInUSD / 10 ** 18 * 0.02) + ')'}
                </div>
            </div>
        </div>
    );
});

const TokenOutput = React.memo(({ onSelectToken, token, balance, amountOut, getTokenPrice, ultraSelections, amountsAreEqual }) => {
    const [balanceUSD, setBalanceUSD] = useState(0);
    const [amountOutUSD, setAmountOutUSD] = useState(0);

    useEffect(() => {
        if (!amountOut || amountOut === 0) {
            setAmountOutUSD(0);
        }
        getTokenPrice(token, amountOut).then(setAmountOutUSD);
    }, [amountOut]);

    useEffect(() => {
        if (!balance || balance === 0) {
            setBalanceUSD(0);
        }
        getTokenPrice(token, balance).then(setBalanceUSD);
    }, [balance]);


    // Determine if the token is an Ultra token to apply specific style
    const isUltraToken = ultraSelections.some(ut => ut.value === token?.value);
    const tokenStyle = isUltraToken ? ultraTokenCardStyle(token?.img) : tokenCardStyle(token?.img);

    return (
        <div style={{ ...tokenStyle, justifyContent: 'start', border: amountsAreEqual ? '2px solid yellow' : 'none', }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <TokenSelectButton onClick={() => onSelectToken('out')} token={token} isUltraSelection={isUltraToken} />
                <div style={{
                    textAlign: 'right', color: 'white', marginLeft: '5px',
                    backgroundColor: 'rgba(0, 0, 0, 0.1)', paddingRight: '10px', paddingLeft: '10px', paddingTop: '8px', paddingBottom: '8px',
                    borderRadius: '10px',
                    alignContent: 'center', justifyContent: 'center', alignItems: 'center', fontSize: '12px',
                }}>
                    <strong>Balance:</strong> {token ? formatDecimals(balance, token.decimals) : '0'} {'(' + formatCurrencyExtended(balanceUSD / 10 ** 18) + ')'}
                </div>
            </div>
            <div
                style={{
                    borderRadius: '15px', //border: '1px solid white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    //color: 'white',
                    paddingBottom: '8px', paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px', marginTop: '5px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <InputNumber
                        value={amountOut / 10 ** token?.decimals || ''}
                        readOnly
                        mode="decimal"
                        minFractionDigits={0}
                        maxFractionDigits={token?.decimals}
                        min={0}
                        style={{ flex: 1, borderRadius: '25px' }}
                        inputStyle={{
                            background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontSize: '24px', fontWeight: 'thin',
                            paddingBottom: '0px', paddingTop: '0px',
                        }}
                        placeholder="0"
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '10px' }}>
                    ~{formatCurrencyExtended(amountOutUSD / 10 ** 18)}
                </div>
            </div>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}> */}
            {/* <Message severity="info" text='Fee Amount: $1.50' style={{ margin: 0 }} /> */}
            {/* </div> */}
        </div>
    );
});



const CustomInput = React.memo(({ value, onChange, placeholder, disabled, decimals }) => {
    const handleInputChange = (e) => {
        const rawValue = e.target.value;
        const formattedValue = rawValue.replace(/[^0-9.]/g, ''); // Remove non-numeric characters
        const decimalIndex = formattedValue.indexOf('.');
        if (decimalIndex !== -1 && formattedValue.length - decimalIndex - 1 > decimals) {
            return; // Prevent entering more than allowed decimals
        }
        onChange(formattedValue);
    };

    return (
        <input
            type="text"
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            disabled={disabled}
            style={{
                width: '100%',
                border: 'none',
                outline: 'none',
                backgroundColor: 'transparent',
                fontSize: '24px',
                fontWeight: 'thin',
                paddingBottom: '0px',
                paddingTop: '0px',
                textAlign: 'right',
            }}
        />
    );
});

CustomInput.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    decimals: PropTypes.number,
};

CustomInput.defaultProps = {
    placeholder: '0',
    disabled: false,
    decimals: 18,
};

